// Local-first save (design doc 16.57, LOCKED interview pass): a real
// `localStorage` entry storing the exact same `GameSaveData` shape the
// server save already uses -- one shared format, not two. Best-effort:
// storage full or unavailable (private browsing) is a silent no-op,
// matching Section 13's "additive, not required" save model.
//
// Wrapped with a `savedAt` timestamp (16.64) so the save-comparison UI
// can show the captain when this save was last written, alongside the
// server save's own `updatedAt` (gameSave.ts).
import type { GameSaveData } from "./gameSave";

const LOCAL_SAVE_KEY = "starforge_save";

export interface LocalSaveEnvelope {
  savedAt: number; // epoch ms
  state: GameSaveData;
}

export function readLocalSave(): LocalSaveEnvelope | null {
  try {
    const raw = localStorage.getItem(LOCAL_SAVE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as LocalSaveEnvelope;
  } catch {
    return null;
  }
}

export function writeLocalSave(data: GameSaveData, nowMs: number): void {
  try {
    const envelope: LocalSaveEnvelope = { savedAt: nowMs, state: data };
    localStorage.setItem(LOCAL_SAVE_KEY, JSON.stringify(envelope));
  } catch {
    // best-effort
  }
}

export function clearLocalSave(): void {
  try {
    localStorage.removeItem(LOCAL_SAVE_KEY);
  } catch {
    // best-effort
  }
}

export function hasLocalSave(): boolean {
  try {
    return localStorage.getItem(LOCAL_SAVE_KEY) !== null;
  } catch {
    return false;
  }
}
